import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { BUSINESS, SERVICES } from "@/lib/content";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#060607] text-white pt-20 pb-10 mt-24 border-t border-[#C9A24B]/20 grain"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        {/* Tagline strip */}
        <div className="mb-16 border-l-2 border-[#C9A24B] pl-6 max-w-3xl">
          <p className="font-serif-display text-xl sm:text-2xl text-white leading-snug">
            "{BUSINESS.tagline}"
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link
              to="/"
              data-testid="footer-logo"
              className="font-serif-display text-2xl tracking-wide text-white hover:text-[#C9A24B] transition-colors"
            >
              Savage <span className="text-[#C9A24B]">Cleaning</span>
            </Link>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              A commercial cleaning solutions provider servicing Brisbane, the Gold Coast and
              South East Queensland.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="gold-rule" />
              <span className="eyebrow">{BUSINESS.region}</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/80 hover:text-[#C9A24B]" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-[#C9A24B]" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/why-us" className="text-white/80 hover:text-[#C9A24B]" data-testid="footer-link-why-us">Why Us</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-[#C9A24B]" data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-[#C9A24B]" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow mb-5">Get in touch</p>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-start gap-3 text-white/85 hover:text-[#C9A24B]" data-testid="footer-phone">
                  <Phone size={18} className="mt-1 text-[#C9A24B]" strokeWidth={1.5} />
                  <span>{BUSINESS.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-3 text-white/85 hover:text-[#C9A24B]" data-testid="footer-email">
                  <Mail size={18} className="mt-1 text-[#C9A24B]" strokeWidth={1.5} />
                  <span>{BUSINESS.email}</span>
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-8 inline-flex items-center gap-2 text-[#C9A24B] uppercase text-xs tracking-[0.25em]"
              data-testid="footer-cta-quote"
            >
              Request a quote <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {SERVICES.map((s) => (
              <Link key={s.slug} to="/services" className="hover:text-[#C9A24B]">
                {s.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
